// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1w4dh","consentsList":"PatientConsents_consentsList__2N4NE","consentsListEmpty":"PatientConsents_consentsListEmpty__1vB2q"};